import * as R from 'ramda';

const addPlacementImage = store => async (state, { rhId, plId, example }) => {
    const userClientId = state.user.selectedUserClientId;
    const rightsholders =
        state.clients[userClientId].settings.client.onboarding.rightsholders;
    const rhIndex = rightsholders.findIndex(rh => rh.id === rhId);
    const plIndex = rightsholders[rhIndex].placements.findIndex(
        pl => pl.id === plId,
    );
    const placement = rightsholders[rhIndex].placements[plIndex];
    const examples = placement.examples
        ? [...placement.examples, example]
        : [example];

    const placementLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
        plIndex,
        'examples',
    ]);

    store.setState(R.set(placementLens, examples, store.getState()), true);
};

export default addPlacementImage;
